<template lang="pug">
div.px-8
  v-row(no-gutters)
    v-col.neutral200.pr-8(cols="3")
      div.sticky.white.fill-height(style="width: 260px; top: 106px;")
        v-skeleton-loader(v-if="isLoading" type="list-item-two-line@3")
        .sticky.top-24.white(v-else)
          .text-md.font-semibold.neutral200.px-4.py-2.rounded-lg {{ $t('queue_system_settings') }}
          ul.mt-3.settings-side-menu
            template(v-for="menu in menus")
              router-link(:to="menu.target" v-slot="{ href, route, navigate, isActive, isExactActive }")
                li.py-2.px-4(@click="navigate" :class="isActive ? 'active' : ''") {{ menu.title }}
          .d-flex.align-center.mt-4.px-4.py-2.clickable(@click="openQueueScreen")
            .text-md.font-semibold.neutral500--text.rounded-lg.mr-2 {{ $t('queue_screen') }}
            v-icon(small) mdi-arrow-top-right
    v-col.neutral200(cols="9")
      v-container.pa-8(v-if="isLoading")
        v-skeleton-loader(type="list-item-two-line@5")
      v-container.pa-8(v-else)
        .d-flex.align-center.mb-6
          v-btn.mr-4(icon small)
            v-icon(color="primary" @click="back") mdi-arrow-left
          .text-2xl.font-semibold {{ $t('queue_system_settings') }}
        
        v-card.round-xl.pa-6.mb-4#configuration(outlined)
          .d-flex
            .flex-grow-1.mr-16
              div(style="max-width:520px")
                .mb-4
                  .text-md.font-semibold {{ $t('queue_system_config') }}
                  .text-sm.font-normal {{ $t('queue_system_config_description') }}
                .mb-8
                  .text-sm.font-medium {{ $t('clear_queue')}}
                  .text-sm.font-normal.neutral500--text.mb-2 {{ $t('clear_queue_description')}}
                  v-text-field.round-xl(v-if="!clearQueueDisabled" v-model="clearQueueAt" outlined placeholder="12:30 am" hide-details="auto" dense height=48 type="time")
                  v-text-field.round-xl.neutral300(v-else outlined placeholder="No timing" hide-details dense height=48 disabled)
                  yc-checkbox.mt-3(v-model="clearQueueDisabled")
                    template(v-slot:label)
                      .text-sm.ml-2 {{ $t('clear_queue_checkbox_description')}}
                .mb-4
                  .text-sm.font-medium {{ $t('call_your_patient_by')}}
                  v-radio-group.mt-1(v-model="callBy")
                    .d-flex.align-center.py-2.mb-2
                      div
                        v-radio(value="number")
                      .ml-1
                        .text-md {{ $t('number')}}
                    .d-flex.align-center
                      div
                        v-radio(value="name")
                      .ml-1
                        .text-md {{ $t('name')}}
                        //- .text-sm.neutral500--text This method is not supported with voices
                .mb-4
                  .d-flex.align-center
                    .flex-grow-1
                      .text-sm.font-medium {{ $t('custom_numbering_group')}}
                      .text-sm.neutral500--text {{ $t('custom_numbering_group_description')}}
                    .ml-2
                      y-switch(v-model="customCodeEnable" :disabled="!isCallTypeNumber")
                v-simple-table.table-custom(v-if="customCodeEnable && isCallTypeNumber")
                  thead
                    tr
                      th Patient type
                      th Code
                      th Number preview
                  tbody
                    tr
                      td Walk-in
                      td
                        .my-2
                          y-select(:items="alphanumericArray" v-model="customCodes.walkIn" attach)
                      td
                        v-sheet.rounded-lg(outlined height="48" color="neutral300")
                          .text-center.mt-3.neutral500--text {{ customCodes.walkIn }}001
                    tr
                      td With appointment
                      td
                        .my-2
                          y-select(:items="alphanumericArray" v-model="customCodes.booking" attach)
                      td
                        v-sheet.rounded-lg(outlined height="48" color="neutral300")
                          .text-center.mt-3.neutral500--text {{ customCodes.booking }}001  
                    tr
                      td Over-the-counter
                      td
                        .my-2
                          y-select(:items="alphanumericArray" v-model="customCodes.overCounter" attach)
                      td
                        v-sheet.rounded-lg(outlined height="48" color="neutral300")
                          .text-center.mt-3.neutral500--text {{ customCodes.overCounter }}001  

            div(style="width:400px")
              preview
                preview-item.mb-4(:title="$t('qtv_preview')")
                  v-card.round-xl.mt-3(width="100%" style="overflow-x: hidden;")
                    .d-flex
                      div
                        .ml-n2.my-5
                          v-skeleton-loader.mb-2(type="sentences" boilerplate width="40")
                          v-skeleton-loader.mb-4(type="image" boilerplate width="50")
                          v-skeleton-loader(type="sentences" boilerplate width="40")
                      .flex-grow-1.pa-2
                        v-card.text-center.rounded-lg.mb-1(elevation="3")
                          .font-bold.pa-2.text-xl {{ isCallTypeNumber ? `${customCodes.walkIn}001` : 'Daniel Amman' }}
                          .px-2.pb-2
                            v-sheet.rounded-lg(:class="themeColor | gradientBackground")
                              .text-md.font-semibold.py-2 Room 1
                        v-card.text-center.rounded-lg.mb-1(elevation="3")
                          .font-bold.pa-2.text-xl {{ isCallTypeNumber ? `${customCodes.walkIn}002` : 'Alex Tan' }}
                          .px-2.pb-2
                            v-sheet.rounded-lg(:class="themeColor | gradientBackground")
                              .text-md.font-semibold.py-2 Room 2
                        v-card.text-center.rounded-lg.mb-1(elevation="3")
                          .font-bold.pa-2.text-xl {{ isCallTypeNumber ? `${customCodes.booking}002` : 'Ravi' }}
                          .px-2.pb-2
                            v-sheet.rounded-lg(:class="themeColor | gradientBackground")
                              .text-md.font-semibold.py-2 Room 3
                        v-card.text-center.rounded-lg(elevation="3")
                          .font-bold.pa-2.text-xl {{ isCallTypeNumber ? `${customCodes.booking}002` : 'Mohd Harith' }}
                          .px-2.pb-2
                            v-sheet.rounded-lg(:class="themeColor | gradientBackground")
                              .text-md.font-semibold.py-2 Room 4

        v-card.round-xl.pa-6.mb-4#room-setup(outlined)
          .mb-6
            .h8 {{ $t('room_setup')}}
            .text-sm {{ $t('room_setup_description')}}

          template(v-if="!isFetchingRooms")
            v-row.pb-2.pb-md-0(no-gutters)
              v-col(cols="12" md="6")
                v-tabs.mb-2.mb-md-0(color="basic700" height="44")
                  v-tab.text-sm.font-normal.text-none(active-class="font-semibold") All

              v-col(cols="12" md="6" align="end")
                .d-flex.align-center
                  v-spacer
                  v-btn(icon color="neutral500")
                    v-icon(size="20") $yzi-search-sm
                  y-button.ml-2.pl-2.pr-4(prependIcon="mdi-plus" iconSize="20" label="Add room" size="sm" outlined @click="addRoom")
            v-divider.mb-6

            div(v-if="rooms.length > 0")
              v-simple-table
                thead.text-table-header
                  tr
                    th Room
                    th Display name
                    th
                tbody
                  tr(v-for="(room, index) in rooms" :key="room.id")
                    td {{ room.name }}
                    td {{ room.qtv_display_name }}
                    td.text-right
                      v-btn(icon small @click="deleteRoom(room)")
                        v-icon(color="neutral700" size="18") $yzi-trash-03
                      v-btn.ml-4(icon small @click="editRoom(room)")
                        v-icon(color="neutral700" size="18") $yzi-edit-05
            div(v-else)
              v-card.round-xl.text-center.pa-8.border-dashed(outlined)
                v-avatar.mb-8(color="neutral300" size="54")
                  v-icon(color="neutral500" size="30") $yzi-lock-keyhole-circle
                .h8 You do not assign any room yet.
                .text-sm.neutral500--text You can start assigning rooms by clicking “+ Add room”
                
          div(v-else)
            v-skeleton-loader(type="list-item-two-line@2")

        v-card.round-xl.pa-6.mb-4#queue-display(outlined)
          .mb-6
            .h8 {{ $t('queue_display')}}
            .text-sm {{ $t('queue_display_description')}}
          .mb-2
            .text-sm.font-medium Choose your QTV ratio
            v-radio-group.mt-1(v-model="tvRatio")
              .d-flex.align-center.mb-2
                div
                  v-radio(value="16:9")
                .ml-1
                  .text-md 16:9
                  .text-sm.neutral500--text Recommended if you have HDTV widescreen TV (Standard TV settings)
              .d-flex.align-center
                div
                  v-radio(value="4:3")
                .ml-1
                  .text-md 4:3
                  .text-sm.neutral500--text Recommended if you have older version TV or monitor

          .mb-2
            .text-sm.font-medium.mb-2 {{ $t('media_type')}}
            v-radio-group.mt-1(v-model="mediaType")
              .d-flex.align-center.mb-2
                div
                  v-radio(value="video")
                .ml-1.text-md {{ $t('video')}}
              .d-flex.align-center
                div
                  v-radio(value="images")
                .ml-1.text-md {{ $t('images')}}
          
          v-form.mb-8(ref="form")
            template(v-if="mediaType === 'video'")
              .text-sm.font-medium Video
              .text-sm.font-normal.neutral500--text.mb-2 You can attach embed video from Youtube.
              v-row(no-gutters)
                v-col(cols=6)
                  v-text-field.round-xl(outlined placeholder="Enter video URL" hide-details="auto" dense height=48 v-model="videoUrl" :rules="mediaType === 'video' ? rules.not_empty : []")
            template(v-else-if="mediaType === 'images'")
              .text-sm.font-medium Images
              .text-sm.font-normal.neutral500--text.mb-4 Upload photos and run it as a media slides in your QTV

              v-row(no-gutters)
                draggable.row.no-gutters(handle=".handle" draggable=".can-drag" :list="photos" @start="drag = true" @end="endMove" :move="checkMove")
                  template(v-for="(photo, index) in photos")
                    v-col.can-drag(cols="4" lg="3" style="padding: 0 16px 16px 0")
                      v-img.round-lg.handle.cursor-grab(:src="photo.image.file | mediumImage" aspect-ratio="1")
                        v-overlay(v-if="isUpdating" absolute opacity="0.2")
                          v-progress-circular(indeterminate color="white" size="30" width="2")
                        .d-flex
                          v-spacer
                          v-menu(offset-y left rounded="lg" attach)
                            template(v-slot:activator="{ on, attrs }")
                              v-btn.neutral100.mr-2.mt-3(icon v-on="on" v-bind="attrs" small)
                                v-icon(color="neutral500" size="20") mdi-dots-vertical
                            v-list.text-sm.py-0
                              v-list-item(@click="deletePhoto(index)")
                                .danger--text {{ $t('delete_photo') }}

                  template(slot="footer")
                    v-col(cols="4" lg="3" style="padding: 0 16px 16px 0")
                      v-card.round-3xl.file-layout(align="center" outlined)
                        v-responsive(aspect-ratio="1")
                          v-row.fill-height(align="center" justify="center")
                            v-progress-circular(v-if="isUploading" indeterminate color="primary" size="30" width="2")
                            .mt-4(v-else)
                              .text-sm.font-normal.info--text
                                v-icon.mb-1(color="info" left size="20") $yzi-upload-01
                                | {{ $t('upload_photo') }}
                              .text-xs.font-normal.neutral500--text.mt-1.px-8 Recommended size ratio: 16:9
                          input.input-change-layout(ref="file" type="file" @change="onFileChange" accept="image/*")

          .mb-2
            .text-sm.font-medium.mb-2 {{ $t('language')}}
            v-radio-group.mt-1(v-model="language")
              .d-flex.align-center.mb-2
                div
                  v-radio(value="en")
                .ml-1.text-md English
              .d-flex.align-center
                div
                  v-radio(value="ms")
                .ml-1.text-md Bahasa Malaysia

          .mb-2
            .text-sm.font-medium.mb-2 Voices
            v-radio-group.mt-1(v-model="voice")
              .d-flex.align-center.mb-2
                div
                  v-radio(value="en")
                .ml-1.text-md(style="width:200px;") English
                v-btn(small icon :disabled="audioIsPlaying" @click="playAudio('en')")
                  v-icon(:color="audioIsPlaying ? 'neutral400' : 'neutral700'") $yzi-play-circle
              .d-flex.align-center.mb-2
                div
                  v-radio(value="ms")
                .ml-1.text-md(style="width:200px;") Bahasa Malaysia
                v-btn(small icon :disabled="audioIsPlaying" @click="playAudio('ms')")
                  v-icon(:color="audioIsPlaying ? 'neutral400' : 'neutral700'") $yzi-play-circle
              .d-flex.align-center
                div
                  v-radio(value="")
                .ml-1.text-md(style="width:200px;") Off
          
          .mb-8
            .text-sm.font-medium {{ $t('scrolling_text')}}
            .text-sm.font-normal.neutral500--text.mb-2 {{ $t('scrolling_text_description')}}
            v-row(no-gutters)
              v-col(cols="6")
                v-textarea.round-xl(placeholder="Enter your chyron text" outlined hide-details="auto" v-model="scrollingText")

          .mb-8
            .text-sm.font-medium {{ $t('company_logo')}}
            .mb-2
              .text-sm.neutral500--text {{ $t('company_logo_description') }}
              .text-sm.neutral500--text Preferred dimension: Aspect ratio of 16:9
            .d-flex.align-center
              v-card(v-if="logoImageFileUrl" flat)
                div(align="center")
                  v-img(:src="logoImageFileUrl" contain height="90" width="140")
                    template(v-slot:placeholder)
                      v-row.fill-height.ma-0(align="center" justify="center")
                        v-progress-circular(indeterminate color="grey")
              v-card.round-xl.border-dashed(v-else outlined width="140")
                .neutral200.text-center.pa-8
                  v-icon(color="neutral500" size="32") $yzi-image-01
              y-button.ml-3(v-if="logoImageFileUrl" size="sm" color="danger" outlined :label="$t('delete')" @click="deleteLogo")
              .file-change-layout.ml-3
                y-button(size="sm" outlined :label="$t('update')")
                input.input-change-layout(type="file" @change="onLogoFileChange" accept="image/*" style="width: 92px !important")

          .preview
            .text-sm.font-medium.mb-2 {{ $t('preview')}}
            y-button.mb-4(:label="$t('change_theme_color')" size="sm" outlined prependIcon="$yzi-palette" iconSize="20" @click="showThemeColorDialog = true")
            v-card(color="neutral200" flat)
              v-responsive(:aspect-ratio="16/9")
                v-card.pa-3(color="neutral300" height="100%")
                  v-row.fill-height(dense)
                    v-col(cols=8)
                      v-card.rounded-lg(elevation="3" height="100%")
                        .d-flex.flex-column.fill-height
                          .d-flex.px-6.py-4.align-center
                            div
                              v-img(:src="logoUrl" contain width="160" height="90")
                            .flex-grow-1.text-right
                              .font-semibold.text-xl {{ previewDate }}
                              .font-semibold.text-xl {{ previewTime }}
                          .flex-grow-1.black#media-container
                            .text-center(v-if="mediaType === 'video'")
                              iframe(width="100%" :height="mediaHeight" :src="getEditedVideoUrl" frameborder="0" allow="autoplay; encrypted-media;")
                            div(v-else)
                              v-carousel(:show-arrows="false" hide-delimiter-background hide-delimiters v-if="photos && photos.length > 0" cycle :height="mediaHeight")
                                v-carousel-item(v-for="photo in photos" :key="photo.id" :src="photo.image.file" cover max-height="100%")
                          div
                            v-sheet.scroll-container(v-if="scrollingText" :color="themeColor")
                              .scroll-text {{ scrollingText }}
                    v-col(cols=4)
                      .d-flex.flex-column.fill-height
                        v-card.text-center.rounded-lg.px-2.py-2.mb-2(elevation="3" height="25%")
                          .d-flex.flex-column.fill-height
                            .flex-grow-1.text-title {{ isCallTypeNumber ? `${customCodes.walkIn}001` : 'Daniel Amman' }}
                            v-sheet.rounded-lg.mx-2(:class="themeColor | gradientBackground")
                              .text-subtitle.py-3 Room 1
                        v-card.text-center.rounded-lg.px-2.py-2.mb-2(elevation="3" height="25%")
                          .d-flex.flex-column.fill-height
                            .flex-grow-1.text-title {{ isCallTypeNumber ? `${customCodes.walkIn}002` : 'Alex Tan' }}
                            v-sheet.rounded-lg.mx-2(:class="themeColor | gradientBackground")
                              .text-subtitle.py-3 Room 2
                        v-card.text-center.rounded-lg.px-2.py-2.mb-2(elevation="3" height="25%")
                          .d-flex.flex-column.fill-height
                            .flex-grow-1.text-title {{ isCallTypeNumber ? `${customCodes.booking}002` : 'Ravi' }}
                            v-sheet.rounded-lg.mx-2(:class="themeColor | gradientBackground")
                              .text-subtitle.py-3 Room 3
                        v-card.text-center.rounded-lg.px-2.py-2.mb-2(elevation="3" height="25%")
                          .d-flex.flex-column.fill-height
                            .flex-grow-1.text-title {{ isCallTypeNumber ? `${customCodes.booking}002` : 'Mohd Harith' }}
                            v-sheet.rounded-lg.mx-2(:class="themeColor | gradientBackground")
                              .text-subtitle.py-3 Room 4

    v-footer.white(app inset padless)
      .d-flex.flex-column.grow
        v-divider
        .d-flex.justify-end.align-center.py-4.px-8
          y-button(label="Cancel" size="sm" color="primary" underline @click="back" :disabled="isSaving")
          y-button.ml-2(label="Save" size="sm" color="primary" @click="save" :loading="isSaving")

    .dialogs
      theme-color-dialog(v-if="showThemeColorDialog" :open.sync="showThemeColorDialog" :parentColor="themeColor" @onSelectColor="onSelectColor")
      add-queue-room-dialog(v-if="showAddEditRoomDialog" :open.sync="showAddEditRoomDialog" :previousRoom="selectedRoom" @onUpdated="reload")
      delete-room-dialog(v-if="showDeleteRoomDialog" :open.sync="showDeleteRoomDialog" :room="selectedRoom" @onDeleted="reload")

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'
import { DateTime } from 'luxon'
import draggable from 'vuedraggable'
import Preview from '@/components/clinic/settings/Preview.vue'
import PreviewItem from '@/components/clinic/settings/PreviewItem.vue'
import ThemeColorDialog from '@/components/clinic/dialogs/ThemeColorDialog.vue'
import AddQueueRoomDialog from '@/components/clinic/dialogs/AddQueueRoomDialog.vue'
import DeleteRoomDialog from '@/components/clinic/dialogs/DeleteRoomDialog.vue'
import msNumber from '@/assets/audio/ms-number.mp3'
import msName from '@/assets/audio/ms-name.mp3'
import enNumber from '@/assets/audio/en-number.mp3'
import enName from '@/assets/audio/en-name.mp3'

export default {
  name: 'QueueSystemSettings',
  components: {
    Preview, PreviewItem, ThemeColorDialog, AddQueueRoomDialog, DeleteRoomDialog, draggable
  },
  data () {
    return {
      isUpdating: false,
      isLoading: false,
      isFetchingRooms: false,
      isFetchingPhotos: false,
      isSaving: false,
      isUploading: false,
      showThemeColorDialog: false,
      showAddEditRoomDialog: false,
      showDeleteRoomDialog: false,
      clearQueueDisabled: false,
      customCodeEnable: true,
      audioIsPlaying: false,
      drag: false,
      settings: null,
      scrollingText: null,
      logoImageFileUrl: null,
      logoImageFile: null,
      selectedRoom: null,
      videoUrl: null,
      fromPhotoId: null,
      mediaHeight: 0,
      clearQueueAt: '10:00',
      callBy: 'number',
      tvRatio: '16:9',
      mediaType: 'images',
      language: 'en',
      voice: 'ms',
      themeColor: '#333333',
      moveParams: {},
      customCodes: {
        walkIn: 1,
        booking: 2,
        overCounter: 3
      },
      rules: {
        not_empty: [val => (val || '').length > 0 || 'This field is required']
      },
      photos: [],
      rooms: [],
      menus: [
        { target: '#configuration', title: 'Configuration' },
        { target: '#room-setup', title: 'Room setup' },
        { target: '#queue-display', title: ' Queue display' },
      ],
      alphanumericArray: [...Array.from({ length: 9 }, (_, i) => i + 1), ...Array(26).fill().map((_, i) => String.fromCharCode(97 + i).toUpperCase())],
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    isCallTypeNumber () {
      return this.callBy === 'number'
    },
    previewTime () {
      return DateTime.local().setLocale(this.localeCode).toFormat('hh:mm a')
    },
    previewDate () {
      return DateTime.local().setLocale(this.localeCode).toFormat('EEEE, dd MMM yyyy')
    },
    logoUrl () {
      return this.settings?.logo?.file
    },
    localeCode () {
      return this.language === 'ms' ? 'ms' : 'en-US'
    },
    isYoutubeWatch () {
      if (this.mediaType !== 'video') return false

      try {
        const url = new URL(this.videoUrl)
        return url?.pathname.includes('/watch')
      } catch (e) {
        return false
      }
    },
    isYoutubePlaylist () {
      if (this.mediaType !== 'video') return false

      try {
        const url = new URL(this.videoUrl)
        return url?.pathname.includes('/playlist')
      } catch (e) {
        return false
      }
    },
    isYoutubeShort () {
      if (this.mediaType !== 'video') return false

      try {
        const url = new URL(this.videoUrl)
        return url?.pathname.includes('/shorts')
      } catch (e) {
        return false
      }
    },
    getEditedVideoUrl () {
      if (this.isYoutubeWatch) {
        const id = this.getYoutubeVideoId(this.videoUrl)
        return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}`
      }

      if (this.isYoutubePlaylist) {
        const id = this.getYoutubePlaylistId(this.videoUrl)
        return `https://www.youtube.com/embed/videoseries?list=${id}&autoplay=1&mute=1&loop=1`
      }

      if (this.isYoutubeShort) {
        const id = this.getYoutubeShortId(this.videoUrl)
        return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}`
      }

      return null
    },
  },
  mounted () {
    this.fetchSettings()
    this.fetchRooms()
    this.fetchPhotos()
    this.setupMediaHeight()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchSettings () {
      this.isLoading = true
      this.$axios.get(`/clinics/${this.company.slug}/registrations/queue_settings`)
        .then(({ data }) => {
          this.settings = data
          this.loadSettings(data)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    fetchRooms () {
      this.isFetchingRooms = true
      this.$axios.get(`/clinics/${this.company.slug}/facilities?qtv=true&fields=id,name,qtv_display_name`)
        .then(({ data }) => {
          this.rooms = data.results
        })
        .catch(() => {
        })
        .finally(() => {
          this.isFetchingRooms = false
        })
    },
    fetchPhotos () {
      this.isFetchingPhotos = true
      this.$axios.get(`/clinics/${this.company.slug}/registrations/qtv_images?page_size=-1`)
        .then(({ data }) => {
          this.photos = data.results
        })
        .catch(() => {
        })
        .finally(() => {
          this.isFetchingPhotos = false
        })
    },
    loadSettings (data) {
      if (data) {
        this.callBy = data.call_by
        if (data.clear_queue_at) {
          this.clearQueueAt = data.clear_queue_at
          this.clearQueueDisabled = false
        } else {
          this.clearQueueDisabled = true
        }
        this.videoUrl = data.video_url
        this.customCodeEnable = data.custom_code_enabled
        this.customCodes.walkIn = data.custom_codes['walk-in']
        this.customCodes.booking = data.custom_codes['booking']
        this.customCodes.overCounter = data.custom_codes['over-the-counter']
        this.mediaType = data.media_type
        this.scrollingText = data.scrolling_text
        this.language = data.text_language
        this.voice = data.voice_language
        if (data.theme_color) {
          this.themeColor = data.theme_color
        }
        this.tvRatio = data.tv_ratio
        this.logoImageFileUrl = data.logo?.file ?? ''
      }
    },
    reload () {
      this.fetchRooms()
    },
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], `queue_photo_${Date.now()}.jpeg`)
      this.uploadPhoto(resizedImage.file)
    },
    uploadPhoto (file) {
      const params = new FormData()
      params.append('image', file)
      this.isUploading = true
      this.$axios.post(`/clinics/${this.company.slug}/registrations/qtv_images`, params)
        .then(resp => {
          this.showAllPhotos = true
          this.photos.push(resp.data)
          this.showMessage(['success', this.$t('success_message.update_successful')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isUploading = false
        })
    },
    deletePhoto (index) {
      this.isUpdating = true
      const photo = this.photos[index]
      this.$axios.delete(`/images/${photo.image.id}`)
        .then(() => {
          this.photos.splice(index, 1)
          this.showMessage(['success', this.$t('success_message.photo_deleted_successfully')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isUpdating = false
        })
    },
    async onLogoFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], 'company_image.jpeg')
      this.logoImageFileUrl = resizedImage.dataURL
      this.logoImageFile = resizedImage.file
    },
    addRoom () {
      this.selectedRoom = null
      this.showAddEditRoomDialog = true
    },
    deleteLogo () {
      this.logoImageFileUrl = null
      this.logoImageFile = null
    },
    deleteRoom (room) {
      this.selectedRoom = room
      this.showDeleteRoomDialog = true
    },
    editRoom (room) {
      this.selectedRoom = room
      this.showAddEditRoomDialog = true
    },
    checkMove (e) {
      const fromPhoto = this.photos[e.draggedContext.index]
      const toPhoto = this.photos[e.draggedContext.futureIndex]
      if (!fromPhoto?.id || !toPhoto?.id) {
        return
      }
      this.moveParams = {
        position: e.draggedContext.futureIndex,
        targetId: toPhoto.id
      }
      this.fromPhotoId = fromPhoto.id
    },
    endMove () {
      this.drag = false
      if (!this.fromPhotoId || !this.settings) {
        return
      }
      if (this.fromPhotoId === this.moveParams.targetId) {
        return
      }
      this.$axios.post(`/clinics/${this.company.slug}/registrations/qtv_images/${this.fromPhotoId}/move/`, this.moveParams).catch(() => {})
    },
    back () {
      this.$router.push('/admin/clinic/settings')
    },
    save () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isSaving = true
      const params = new FormData()
      params.append('call_by', this.callBy)
      if (!this.clearQueueDisabled) {
        if (this.clearQueueAt) {
          params.append('clear_queue_at', this.clearQueueAt)
        }
      } else {
        params.append('clear_queue_at', '')
      }
      params.append('custom_code_enabled', this.customCodeEnable)
      params.append('custom_codes', JSON.stringify({
        'walk-in': this.customCodes.walkIn,
        'booking': this.customCodes.booking,
        'over-the-counter': this.customCodes.overCounter,
      }))
      params.append('media_type', this.mediaType)
      params.append('scrolling_text', this.scrollingText)
      params.append('text_language', this.language)
      params.append('voice_language', this.voice)
      params.append('theme_color', this.themeColor)
      params.append('tv_ratio', this.tvRatio)
      if (this.logoImageFile) {
        params.append('logo', this.logoImageFile)
      }
      if (this.videoUrl) {
        params.append('video_url', this.videoUrl)
      }

      this.$axios.patch(`/clinics/${this.company.slug}/registrations/queue_settings`, params)
        .then(resp => {
          this.settings = resp.data
          this.showMessage(['success', this.$t('success_message.update_successful')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isSaving = false
        })
    },
    onSelectColor (color) {
      this.themeColor = color
    },
    openQueueScreen () {
      window.open(`https://${this.company.slug}.yezza.co/qtv`, '_blank')
    },
    getYoutubeVideoId (link) {
      let id = ''
      if (link) {
        try {
          const url = new URL(link)
          id = url?.searchParams.get('v')
        } catch (e) {
          console.log(e)
        }
      }
      return id
    },
    getYoutubePlaylistId (link) {
      let id
      if (link) {
        try {
          const url = new URL(link)
          id = url?.searchParams.get('list')
        // eslint-disable-next-line no-empty
        } catch (e) {}
      }
      return id
    },
    getYoutubeShortId (link) {
      let id
      if (link) {
        try {
          const url = new URL(link)
          const pathname = url?.pathname.split('/')
          id = pathname[pathname.length - 1]
        // eslint-disable-next-line no-empty
        } catch (e) {}
      }
      return id
    },
    playAudio (lang) {
      let audio = null
      if (lang === 'en' && this.callBy === 'number') {
        audio = new Audio(enNumber)
        audio.play()
      } else if (lang === 'en' && this.callBy === 'name') {
        audio = new Audio(enName)
        audio.play()
      } else if (lang === 'ms' && this.callBy === 'number') {
        audio = new Audio(msNumber)
        audio.play()
      } else if (lang === 'ms' && this.callBy === 'name') {
        audio = new Audio(msName)
        audio.play()
      }
      audio.addEventListener('playing', () => {
        this.audioIsPlaying = true
      })
      audio.addEventListener('pause', () => {
        this.audioIsPlaying = false
      })
    },
    // getEditedVideoUrl () {
    //   if (this.isYoutubeWatch) {
    //     const id = this.getYoutubeVideoId(this.videoUrl)
    //     return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}`
    //   }

    //   if (this.isYoutubePlaylist) {
    //     const id = this.getYoutubePlaylistId(this.videoUrl)
    //     return `https://www.youtube.com/embed/videoseries?list=${id}&autoplay=1&mute=1&loop=1`
    //   }

    //   if (this.isYoutubeShort) {
    //     const id = this.getYoutubeShortId(this.videoUrl)
    //     return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}`
    //   }

    //   return null
    // },
    // getEditedVideoUrl () {
    //   const id = this.getYoutubeVideoId(this.videoUrl)
    //   if (id) {
    //     return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}`
    //   }
    //   return ''
    // },
    setupMediaHeight () {
      const mediaContainerHeight = document.getElementById('media-container').clientHeight
      if (mediaContainerHeight) {
        this.mediaHeight = mediaContainerHeight
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.file-change-layout {
  position: relative;
}

.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}

.queue-system-settings {
  background-color: var(--v-neutral200);
  min-height: 90vh;
}

.scroll-container {
  color: #ffffff;
  overflow: hidden !important;
  white-space: nowrap;
  padding: 16px;
}

.scroll-text {  
  transform: translateX(100%);
  animation: scroll-animation 15s linear infinite;
}

@keyframes scroll-animation {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(-100%);
  }
}

.file-layout {
  position: relative;
  cursor: pointer;
  border: var(--v-neutral400) dashed 1px;
}

.text-title {
  font-weight: 600;
  font-size: 2rem;
  align-self: center;
  display: flex;
  align-items: center;
}

.text-subtitle {
  font-weight: 600;
  font-size: 1.5rem;
}

::v-deep {
  .table-custom {
    .v-data-table__wrapper {
      overflow: visible !important;
    }
  } 
}
</style>